//constants
import {
  AFFORD_TOPIC_KEY,
  INVESTMENT_TOPIC_KEY,
  PREQUAL_TOPIC_KEY,
} from '../../../../constants/directMessages'

const FooterQuestions = [
  {
    topic: `a Listing they viewed`,
    topicKey: AFFORD_TOPIC_KEY,
    message: 'Can I afford this home?',
  },
  {
    topic: `a Listing they viewed`,
    topicKey: INVESTMENT_TOPIC_KEY,
    message: 'Is this home a good investment?',
  },
  {
    topic: `a Listing they viewed`,
    topicKey: PREQUAL_TOPIC_KEY,
    message: 'Can I get pre-qualified for this home?',
  },
]

export default FooterQuestions
